var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 11.25a1 1 0 011-1H12a1 1 0 011 1v4.282a1 1 0 01-.25 1.968H12a1 1 0 01-1-1v-4.282a1 1 0 01-.75-.968zM13.125 7.875a1.125 1.125 0 11-2.25 0 1.125 1.125 0 012.25 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.2 12c0-5.412 4.388-9.8 9.8-9.8 5.412 0 9.8 4.388 9.8 9.8 0 5.412-4.388 9.8-9.8 9.8-5.412 0-9.8-4.388-9.8-9.8zM12 3.8a8.2 8.2 0 100 16.4 8.2 8.2 0 000-16.4z",
    fillRule: "evenodd"
  }))));
}

export default SvgInfo;